// extracted by mini-css-extract-plugin
module.exports = {"cancel":"CancelButton__cancel___3xfB_","alignLeft":"CancelButton__alignLeft___1qNW7"};